"use client"
import React, { useEffect } from "react";
import Image from "next/image";
import { Carousel } from "@material-tailwind/react";
import Link from "next/link";
import { useDispatch, useSelector } from "react-redux";
import { getBannerStart, getBannerSuccess } from "@/GlobalRedux/Slices/allBanners";
export function Herosection({bannerData}) {
  const dispatch = useDispatch()
 const getAllBanner = async () => {
  dispatch(getBannerStart()) 
   dispatch(getBannerSuccess(bannerData))

 }
 const { allBanners, isLoader } = useSelector((state) => state.allBanner)
// console.log("ALL BANNERS",allBanners)
useEffect(()=>{
  getAllBanner()
},[])
  const slides = [
    {
      image: "/Images/banner_mys.png",
      link:"/products/ARMAF-Bucephalus-No.-IX-Men-67c3d59f9437e13bc81b1ed5"
    },
    {
      image: "/Images/banner_mys3.png",
      link:"/products?brand=ARMAF"

    },
    {
      image: "/Images/banner3.png",
      link:"/products"

    },
  ];
  let bannersData = allBanners?.length > 0 ? allBanners : slides;
  return (
    <Carousel  
    loop={true} 
    autoplay={true} 
    className=" h-1/4 sm:h-1/2 bg-[#C9C9C9] relative z-9999"
    navigation={({ setActiveIndex, activeIndex, length }) => (
      <div className="absolute bottom-4 left-2/4 z-9999 flex -translate-x-2/4 gap-2">
        {new Array(length).fill("").map((_, i) => (
          <span
            key={i}
            className={`block h-1 cursor-pointer rounded-2xl transition-all content-[''] ${
              activeIndex === i ? "w-8 bg-white " : "w-4 bg-white/50"
            }`}
            onClick={() => setActiveIndex(i)}
          />
        ))}
      </div>
    )}
    >
     {bannersData?.map((item,index)=>(
        <span key={index}>
         <Link href={item?.productURL || item?.link}>
        <Image
        src={(item?.images && item?.images.length > 0) ? item.images[0] : item?.image}
        height={1000}
        width={1000}
        loading="lazy"
        alt="herosection mystical fragrance"
        className="h-64 md:h-80 lg:h-96  w-full "
        />
        </Link> 
        </span>
     )) 
     }
    </Carousel>
  );
}

